"use strict";

import "particles.js";

const PARTICLE_CONTAINER_ID = "page--hero-home-particles";

/**
 * Legge una variabile CSS su :root e restituisce un hex (#rrggbb) per particles.js.
 */
function getCssHexVar(name) {
    let raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!raw) {
        return "";
    }
    if (raw.startsWith("#")) {
        if (raw.length === 4) {
            return (
                "#" +
                raw[1] +
                raw[1] +
                raw[2] +
                raw[2] +
                raw[3] +
                raw[3]
            );
        }
        return raw;
    }
    const probe = document.createElement("span");
    probe.style.setProperty("color", `var(${name})`);
    document.body.appendChild(probe);
    const computed = getComputedStyle(probe).color;
    document.body.removeChild(probe);
    const m = computed.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!m) {
        return "";
    }
    const hex = (i) => Number(m[i]).toString(16).padStart(2, "0");
    return `#${hex(1)}${hex(2)}${hex(3)}`;
}

/**
 * Opzioni allineate a crafto demo-recruitment.html (particles-style-01).
 * Colori da --primary-300 … --primary-500 (incluso --primary-400 come intermedio).
 */
function getParticleOptions() {
    const c300 = getCssHexVar("--primary-300") || "#D2FA94";
    const c400 = getCssHexVar("--primary-400") || "#8FD622";
    const c500 = getCssHexVar("--primary-500") || "#2F4E00";

    return {
        particles: {
            number: {
                value: 7,
                density: { enable: true, value_area: 800 },
            },
            color: { value: [c300, c400, c500] },
            shape: {
                type: "circle",
                stroke: { width: 0, color: c500 },
                polygon: { nb_sides: 5 },
                image: { src: "", width: 100, height: 100 },
            },
            opacity: {
                value: 0.5,
                random: false,
                anim: {
                    enable: false,
                    speed: 1,
                    opacity_min: 0.1,
                    sync: false,
                },
            },
            size: {
                value: 4,
                random: true,
                anim: {
                    enable: false,
                    speed: 40,
                    size_min: 0.1,
                    sync: false,
                },
            },
            line_linked: {
                enable: false,
                distance: 150,
                color: "#ffffff",
                opacity: 0.4,
                width: 1,
            },
            move: {
                enable: true,
                speed: 6,
                direction: "none",
                random: false,
                straight: false,
                out_mode: "out",
                bounce: false,
                attract: { enable: false, rotateX: 600, rotateY: 1200 },
            },
        },
        interactivity: {
            detect_on: "canvas",
            events: {
                onhover: { enable: true, mode: "repulse" },
                onclick: { enable: true, mode: "push" },
                resize: true,
            },
            modes: {
                grab: { distance: 400, line_linked: { opacity: 1 } },
                bubble: {
                    distance: 400,
                    size: 40,
                    duration: 2,
                    opacity: 8,
                    speed: 3,
                },
                repulse: { distance: 200, duration: 0.4 },
                push: { particles_nb: 4 },
                remove: { particles_nb: 2 },
            },
        },
        retina_detect: true,
    };
}

function cancelParticleFrame(inst) {
    const id = inst?.pJS?.fn?.drawAnimFrame;
    if (id == null) {
        return;
    }
    const caf = window.cancelRequestAnimFrame || window.cancelAnimationFrame;
    if (typeof caf === "function") {
        caf(id);
    }
}

/**
 * Rimuove istanze particles.js legate all'hero home o canvas orfani (navigazione Swup).
 */
export function destroyHomeHeroParticles() {
    if (typeof window === "undefined" || !window.pJSDom || !Array.isArray(window.pJSDom)) {
        return;
    }
    window.pJSDom = window.pJSDom.filter((inst) => {
        const el = inst?.pJS?.canvas?.el;
        if (!el) {
            return false;
        }
        const host = el.parentElement;
        const isHero = host && host.id === PARTICLE_CONTAINER_ID;
        const orphan = !el.isConnected;
        if (isHero || orphan) {
            cancelParticleFrame(inst);
            if (el.isConnected) {
                el.remove();
            }
            return false;
        }
        return true;
    });
}

export function initHomeHeroParticles() {
    const el = document.getElementById(PARTICLE_CONTAINER_ID);
    const particlesJS = window.particlesJS;
    if (!el || typeof particlesJS !== "function") {
        return;
    }

    destroyHomeHeroParticles();
    particlesJS(PARTICLE_CONTAINER_ID, getParticleOptions());
}
